import { Component, Output, EventEmitter, ViewChild } from '@angular/core';
import { ModalService } from '../../shared/services/modal.service';
import { ApplicationActions } from '../../actions/application.actions';
import { QuestionnaireService } from '../../shared/services/questionnaire.service';

@Component({
  selector: 'md-cash-vested-modal',
  template: require('./cash-vested-modal.component.html'),
  styles: [require('./cash-vested-modal.component.scss')]
})

export class CashVestedModalComponent {

  @Output() closeEmitter = new EventEmitter();
  confirmation = false;
  buttons = new Map([
    [false, {
      confirmButton: {
        text: 'Confirm',
        action: 'confirm'
      },
      cancelButton: {
        text: 'Cancel',
        action: 'close'
      }
    }
    ],
    [true, {
      confirmButton: {
        text: 'Yes, update portfolio',
        action: 'confirmed'
      },
      cancelButton: {
        text: 'No, take Me Back',
        action: 'close'
      }
    }
    ]
  ]);
  @ViewChild('focusItem') focusItem;

  constructor(modal: ModalService,
    appActions: ApplicationActions,
    questionnaire: QuestionnaireService) {
    this.modal = modal;
    this.appActions = appActions;
    this.isCashVested = this.appActions.getData('goalSession.isCashVested');
    this.originalSelection = this.isCashVested;
    this.strategy = this.appActions.getData('goalSession.strategy');
    this.questionnaire = questionnaire;
    this.cashPrefix = this.isCashVested ? 'Stay' : 'Go';
    this.vestedPrefix = !this.isCashVested ? 'Stay' : 'Go';
  }

  ngAfterViewInit() {
    if (this.focusItem) {
      setTimeout(() => {
        this.focusItem.nativeElement.focus();
      }, 0);
    }
  }

  buttonClick(event) {
    if (event === 'close') {
      this.closeEmitter.emit();
    } else if (event === 'confirm') {
      this.selection();
    } else if (event === 'confirmed') {
      this.confirmed();
    }
  }

  selection() {
    if (!this.isCashVested && this.originalSelection) { // Selecting fully vested if they were cash enhanced
      this.confirmation = true;
    } else if (this.isCashVested && !this.originalSelection) { // Selecting cash enhanced if fully vested
      this.appActions.setData('goalSession.isCashVested', true);
      this.appActions.setData('goalSession.strategy', this.questionnaire.toggleStrategy(this.strategy));
      this.questionnaire.updatePortfolio();
      this.closeEmitter.emit();
    } else {
      this.closeEmitter.emit();
    }
  }

  confirmed() {
    this.appActions.setData('goalSession.isCashVested', false);
    this.appActions.setData('goalSession.strategy', this.questionnaire.toggleStrategy(this.strategy));
    this.questionnaire.updatePortfolio();
    this.closeEmitter.emit();
  }
}
